import React, {Component, useState} from 'react';
import * as InitStatus from "../../../constants/common/InitializationStatus";
import {number_format} from "../../../utils/formatter";
import autobind from "autobind-decorator";
import fetch from "fetch-retry";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import { connect } from "react-redux";
import If from "../../common/control/If";
import {addPrefix} from "../../../utils/UriUtil";


@connect(state => ({
  entryId: state.statistics.entryId,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
}), dispatch => ({dispatch}))
class InflowTopLayer extends Component {

  constructor(props) {
    super(props);
    this.state = {refTop: []}
  }


  shouldComponentUpdate(nextProps, nextState) {
    const {isLayerOpen} = nextProps;
    if (this.props.isLayerOpen != isLayerOpen && isLayerOpen) {
      document.body.classList.add('popup_show');
      this.getRefTop();
    }
    return true;
  }

  @autobind
  getRefTop() {
    const {dispatch, entryId, activeDate, activeDateType, refType} = this.props;

    this.setState({initialized: InitStatus.INIT_DOING});

    const url = (refType === 'entry')
      ? addPrefix(`/manage/statistics/entry/${entryId}/${activeDate}/${activeDateType}/topRef.json`)
      : addPrefix(`/manage/statistics/blog/${activeDate}/${activeDateType}/topRef.json`);

    fetch(url, {
      credentials: 'include',
      headers: {'Content-Type': 'application/json'},
      retries: 3,
      retryDelay: 300,
      retryOn: [500]
    })
      .then(jsonResponseHandler(dispatch))
      .then(res => res.json())
      .then(res => {

        const list = res.data.hasOwnProperty('result') ? res.data.result : [];
        this.setState({
          refTop: list,
          initialized: InitStatus.INIT_SUCCESS
        })
      })
      .catch(e => {
        console.error('error:', e);
        this.setState({
          initialized: InitStatus.INIT_FAIL
        });
        alert('통계 정보를 조회할 수 없습니다. 잠시 후 다시 시도해 주시기 바랍니다.');
      })
  }


  /**
   * dimm div보다 popup layer의 z-index가 낮아 상위 div에 이벤트를 걸어 closeable을 체크한다.
   * @param e
   */
  @autobind
  closeLayer(e) {
    if (e.target.className.indexOf('closeable') > -1) {
      this.props.changeShowInflowLayer(false);
      document.body.classList.remove('popup_show');
    }
  }

  /**
   * Decode중 에러가 발생하면 주소를 그냥 보여준다.
   * @param ref
   * @returns {*}
   */
  decodeUrl(ref) {
    try {
      return decodeURIComponent(ref);
    } catch (e) {
      return ref
    }
  }

  renderLoading() {
    return <div className="date_loading">
      <div className="inner_g"><span className="ico_blog ico_loading">로딩중입니다.</span></div>
    </div>
  }

  renderItems(list) {
    return list.map((item, index) => (
      <dl className="list_incomming" key={index}>
        <dt><a href={item.ref} target="_blank" className="link_tit">{this.decodeUrl(item.ref)}</a></dt>
        <dd>{number_format(item.count)}</dd>
      </dl>
    ))
  }


  render() {
    const {isLayerOpen} = this.props;
    const {refTop, initialized} = this.state;
    const {isDoing, isSuccess} = InitStatus.init(initialized, refTop);

    return (
      <div>
        <If condition={isLayerOpen}>
          <div>
            <span className="dimm_g"></span>
            <div className="popup_type1">
              <div className="inner_popup closeable" onClick={this.closeLayer}>
                <div className="incomming_cont">
                  <div className="layer_head"><strong className="tit_popup">기타 유입<span
                    className="desc_tit">상위 20개</span></strong>
                  </div>
                  <div className="layer_body">
                    <If condition={isDoing}>{this.renderLoading()}</If>
                    <If condition={!isDoing}>
                      <div className="inner_layer_body">{this.renderItems(refTop)}</div>
                    </If>
                  </div>
                  <div className="layer_foot">
                    <button className="btn_close closeable">닫기</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </If>
      </div>
    );
  }
}

export function InflowTopLayerButton(props) {
  const {disableBtn, refType} = props;
  const [isLayerOpen, setIsLayerOpen] = useState(false);
  return <div className="box_incomming">
    <button className="incoming_detail" disabled={disableBtn} onClick={() => {
      setIsLayerOpen(true)
    }}>기타 유입 자세히 보기
    </button>
    <InflowTopLayer
      refType={refType}
      changeShowInflowLayer={setIsLayerOpen}
      isLayerOpen={isLayerOpen}
    />
  </div>
}

export default InflowTopLayer;
